var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'circle-indicator ' + _vm.getColor})
}
var staticRenderFns = []

export { render, staticRenderFns }